import {
  createStyles,
  Container,
  Text,
  Group,
  SimpleGrid,
  rem,
  Image,
} from "@mantine/core";
import * as React from "react";

const useStyles = createStyles((theme) => ({
  root: {
    paddingTop: rem(100),
    paddingBottom: rem(40),
  },

  title: {
    // fontWeight: 900,
    fontSize: rem(50),
    marginBottom: theme.spacing.md,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,

    [theme.fn.smallerThan("sm")]: {
      fontSize: rem(28),
    },
  },

  control: {
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
    },
  },

  mobileImage: {
    [theme.fn.largerThan("sm")]: {
      display: "none",
    },
  },

  desktopImage: {
    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },
}));

export function AboutPage() {
  const { classes } = useStyles();

  return (
    <Container className={classes.root}>
      <div>
        <Text className={classes.title}>about the stamp book</Text>
      </div>
      <br />
      <SimpleGrid
        spacing={80}
        cols={2}
        breakpoints={[{ maxWidth: "sm", cols: 1, spacing: 40 }]}
      >
        <div>
          {/* <Group sx={{ height: "100%" }} spacing={20}> */}
          <Text size="lg">
            On this website there are 179 stamps scanned from my mom and uncle’s
            stamp album, representing 26 different countries. I have deeply
            admired it since I first found the album at my grandparents’ house
            in Chennai when I was around 11. Their collection inspired me to
            start collecting stamps too (mine aren’t included in this
            compilation) and I enjoyed looking at the wide variety of subjects
            represented, from animals and people to different regions and eras.
            I love how there can be so many diverse patterns, styles,
            techniques, and textures existing on just one stamp, a little fleck
            of paper. And many times I wonder: what exactly makes a subject
            worthy of putting on a country’s stamp?
          </Text>
          <br />

          <Text size="lg">
            They grew up in India and Mauritius, so most of the stamps are from
            these countries and surrounding countries, many of which were former
            British colonies. In researching the stamps in the book (mostly
            through google image search and colnect and wikipedia) it was
            fascinating to dive more into the histories and details behind them
            and I have gathered an assortment of links that relate to each
            stamp!
          </Text>
          <br />

          <Text size="lg" italic>
            This website is a companion to a printed book :)
          </Text>
          <br />
          <Text size="lg">{"- vidya <3 "}</Text>
          {/* </Group> */}
          <Group mt={30}>
            <Text size="md">
              <a href="https://vidyagiri.com"> vidya's website</a>
            </Text>

            <Text size="md">
              <a href="https://ixora.vidyagiri.com"> ixora press website</a>
            </Text>
          </Group>
        </div>
        <div>
          <Image
            height={"38vh"}
            fit="contain"
            src={`https://vidyagiri.com/stamps/img/about-1.png`}
          />
          <br />
          <Image
            height={"38vh"}
            fit="contain"
            src={`https://vidyagiri.com/stamps/img/about-2.png`}
          />
        </div>
      </SimpleGrid>
      <br />

      <Group mt={30}>
        <div>
          <Text className={classes.title}>all stamps</Text>
          <Image
            fit="contain"
            src={`https://vidyagiri.com/stamps/img/all-stamps-1.png`}
          />
          <br />
          <Image
            fit="contain"
            src={`https://vidyagiri.com/stamps/img/all-stamps-2.png`}
          />
        </div>
      </Group>
    </Container>
  );
}
